// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const contentWrapper = "Logout__contentWrapper__DeIQ2";
export const share = "Logout__share__0OkLh";
export const shareText = "Logout__shareText__VSjMd font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const shareButtons = "Logout__shareButtons__DPr7D";
export const shareButtonWrapper = "Logout__shareButtonWrapper__BRV75";
export const emailSection = "Logout__emailSection__pETUh font-faces__sansMedium__DqLMY font-faces__sans__uCf65";